import React, { useState, useEffect, useRef } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import _ from 'lodash'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'

function DynamicCategorize(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isResetClick
  } = props
  const {
    AnswerColorFill,
    AnswerFillColor,
    AnswerFontSize,
    AnswerType,
    Background,
    ControlID,
    CorrectAnswerExplanation,
    EditorImageHeight,
    EditorImageWidth,
    HotSpot,
    IncorrectAnswerExplanation,
    Opacity,
    QuestionColorFill,
    QuestionFillColor,
    QuestionFontSize,
    QuestionText,
    DisplayType = 'Slot',
    FontStyle,
    Italic,
    Bold
  } = mcData

  const isFreeForm = DisplayType === 'freeform'

  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const [imageDimension, setImageDimension] = useState({
    height: 0,
    width: 0
  })
  const [hotSpotList, sethotSpotList] = useState(HotSpot)

  const [droppedObjects, setDroppedObjects] = useState({})
  const [headerObjects, setHeaderObjects] = useState([])
  const [currentDropArea, setcurrentDropArea] = useState(-1)
  const [currentHeaderItem, setCurrentHeaderItem] = useState()
  const [success, setSuccess] = useState(false)
  const [showTestColor, setShowTestColor] = useState(false)
  const [currentAttempts, setCurrentAttempts] = useState(0)
  const imgRef = useRef()
  const [dropItemCoord, setDropItemCoord] = useState({})

  useEffect(() => {
    let hotSpotCopy = [...HotSpot]
    if (isResetClick) {
      let headerObjectsCopy = []
      hotSpotCopy.forEach((hotspot) => {
        hotspot.Answers.forEach((a) => headerObjectsCopy.push(a))
      })
      setHeaderObjects(blindShuffle(headerObjectsCopy))
      setDroppedObjects({})
      setcurrentDropArea(-1)
      setCurrentHeaderItem(undefined)
      setDropItemCoord({})
    } else {
      if (defaultValue) {
        const { headerObjects, currentAttempts } = defaultValue.CtlValue
        setHeaderObjects(headerObjects)
        setCurrentAttempts(currentAttempts)
      } else {
        let headerObjectsCopy = []
        hotSpotCopy.forEach((hotspot) => {
          hotspot.Answers.forEach((a) => headerObjectsCopy.push(a))
        })
        setHeaderObjects(blindShuffle(headerObjectsCopy))
      }
    }

    sethotSpotList(HotSpot)
  }, [defaultValue, isResetClick])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(
        droppedObjects,
        headerObjects,
        currentAttempts,
        true
      )
    }
  }, [timerEnd])

  useEffect(() => {
    if (isImageLoaded) {
      if (defaultValue) {
        const { modifiedDroppedObjects } = defaultValue.CtlValue

        const tempDroppedObj = { ...modifiedDroppedObjects }
        Object.keys(modifiedDroppedObjects).forEach((key) => {
          let modifiedArray = []

          tempDroppedObj[key].forEach((d) => {
            const newLayoutCoords = {
              left: (d.layoutCoords.left * imgRef.current.width) / 100,
              top: (d.layoutCoords.top * imgRef.current.height) / 100
            }
            modifiedArray.push({
              item: d.item,
              layoutCoords: newLayoutCoords
            })
          })
          tempDroppedObj[key] = modifiedArray
        })
        setDroppedObjects(tempDroppedObj)
      }
      setImageDimension({
        width: imgRef.current.width,
        height: imgRef.current.height
      })
    }
  }, [isImageLoaded, defaultValue])

  useEffect(() => {
    if (explanationClick) {
      let isCorrect = false
      if (Object.keys(droppedObjects).length === hotSpotList.length) {
        for (const key in droppedObjects) {
          const hpot = hotSpotList.find((h) => h.ID === key)
          if (
            Object.prototype.hasOwnProperty.call(droppedObjects, key) &&
            hpot
          ) {
            const answers = hpot.Answers.filter((a) => !a.IsDecoy)
            const onlyAnswers = answers.map((a) => a.Answer)
            const droppedAnswers = droppedObjects[key].map((a) => a.item.Answer)
            let temp = true
            const sortedOnlyAnswers = onlyAnswers.sort()
            const sortedDroppedAnswers = droppedAnswers.sort()
            if (
              JSON.stringify(sortedOnlyAnswers) !==
              JSON.stringify(sortedDroppedAnswers)
            ) {
              temp = false
            }

            if (temp) {
              isCorrect = true
            } else {
              isCorrect = false
              break
            }
          }
        }
      }
      if (isCorrect) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }, [explanationClick])

  function onDragging(h) {
    setCurrentHeaderItem(h)
  }

  function allowDrop(ev) {
    ev.preventDefault()
    const obj = {
      x: ev.nativeEvent.offsetX,
      y: ev.nativeEvent.offsetY
    }
    setDropItemCoord(obj)
  }

  function dropAreaOperations(ev, currentDropArea) {
    ev.preventDefault()
    if (currentHeaderItem) {
      const droppedHotspot = hotSpotList.find((hp) => hp.ID === currentDropArea)
      if (isPractice && droppedHotspot) {
        const answers = droppedHotspot.Answers.map((a) => a.Answer)
        const isPresent = answers.includes(currentHeaderItem.Answer)
        if (isPresent && !currentHeaderItem.IsDecoy) {
          displaySelectedColor(true)
          handleSuccessChange(true)
        } else {
          displaySelectedColor(false)
          handleSuccessChange(false)
        }
      }
      setcurrentDropArea(currentDropArea)
      //save currentitem and dropped coordinates
      let currentHeaderItemCopy = {
        item: currentHeaderItem,
        layoutCoords: {
          left: dropItemCoord.x,
          top: dropItemCoord.y
        }
      }

      let droppedObjectsCopy = { ...droppedObjects }
      if (droppedObjectsCopy[currentDropArea]) {
        droppedObjectsCopy[currentDropArea].push(currentHeaderItemCopy)
      } else {
        droppedObjectsCopy[currentDropArea] = [currentHeaderItemCopy]
      }
      setDroppedObjects(droppedObjectsCopy)
      let headerObjectsCopy = [...headerObjects].filter(
        (ho) =>
          ho.Answer.toString() !== currentHeaderItemCopy.item.Answer.toString()
      )
      setHeaderObjects(headerObjectsCopy)
      let currentAttemptsCopy = currentAttempts + 1
      setCurrentAttempts(currentAttemptsCopy)
      setCurrentHeaderItem(undefined)
      validateCorrectAnswer(
        droppedObjectsCopy,
        headerObjectsCopy,
        currentAttemptsCopy
      )
    }
  }

  function displaySelectedColor(correct) {
    setShowTestColor(true)
    setSuccess(correct)
    setTimeout(() => {
      setShowTestColor(false)
      setcurrentDropArea(-1)
    }, 1000)
  }

  function validateCorrectAnswer(
    droppedObjectsCopy,
    headerObjectsCopy,
    currentAttemptsCopy,
    timerValue
  ) {
    let totalScore = 0
    let currentScore = 0
    let noOfCorrectAnswer = 0
    let totalAnswerCount = 0
    hotSpotList.forEach((h) => {
      totalScore += h.Score
    })

    hotSpotList.forEach((h) => {
      h.Answers.forEach((a) => {
        if (!a.IsDecoy) {
          totalAnswerCount++
        }
      })
    })

    for (const key in droppedObjectsCopy) {
      const hpot = hotSpotList.find((h) => h.ID === key)
      if (
        Object.prototype.hasOwnProperty.call(droppedObjectsCopy, key) &&
        hpot
      ) {
        const hpotAnswers = hpot?.Answers.sort()
        const withoutDecoy = hpotAnswers.filter((h) => !h.IsDecoy)
        const answerWithoutDecoy = withoutDecoy.map((w) => w.Answer)
        droppedObjectsCopy[key].forEach((d) => {
          if (answerWithoutDecoy.includes(d.item.Answer)) {
            noOfCorrectAnswer++
          }
        })
      }
    }

    // (a/(greater of(b, d)))*c
    // a-no of correct answers
    // b-attemps
    // c- total score
    // d- total items in bin
    //new score calculation
    currentScore =
      (noOfCorrectAnswer / Math.max(currentAttemptsCopy, totalAnswerCount)) *
      totalScore
    currentScore = parseFloat(currentScore.toFixed(1))

    const modifiedDroppedObjects = { ...droppedObjectsCopy }
    Object.keys(modifiedDroppedObjects).forEach((key) => {
      let modifiedArray = []
      modifiedDroppedObjects[key].forEach((d) => {
        const newLayoutCoords = {
          left: (d.layoutCoords.left / imageDimension.width) * 100,
          top: (d.layoutCoords.top / imageDimension.height) * 100
        }
        modifiedArray.push({
          item: d.item,
          layoutCoords: newLayoutCoords
        })
      })
      modifiedDroppedObjects[key] = modifiedArray
    })

    const controlList = {
      modifiedDroppedObjects: modifiedDroppedObjects,
      headerObjects: headerObjectsCopy,
      currentAttempts: currentAttemptsCopy
    }
    if (currentScore) {
      onValueChange(
        ControlID,
        controlList,
        currentScore,
        totalScore,
        '',
        timerValue
      )
    } else {
      onValueChange(ControlID, controlList, 0, totalScore, '', timerValue)
    }
    onAttemptChange(1)
  }

  return (
    <div className='dyn-slide-comp-wrapper'>
      <div className='dyn-items-cont'>
        {isImageLoaded &&
          !isVerifyMode &&
          headerObjects?.map((h, i) => (
            <div
              key={i.toString()}
              className='dyn-header-item'
              style={{
                backgroundColor: AnswerFillColor
              }}
              draggable='true'
              onDragStart={() => onDragging(h)}
            >
              <RectangleContent
                contentType={AnswerType}
                contentData={h.Answer}
              />
            </div>
          ))}
      </div>
      <div className='dyn-canvas-cont'>
        <SlideQuestion
          QuestionText={QuestionText}
          QuestionType={'text'}
          QuestionColorFill={QuestionColorFill}
          QuestionFillColor={QuestionFillColor}
          QuestionFontSize={QuestionFontSize}
          QuestionFontFamily={FontStyle}
          QuestionFontWeight={Bold}
          QuestionFontStyle={Italic}
        />
        <div className='smartslide-answer-main-container'>
          <div className='dyn-bg-cont'>
            <img
              id='parentView'
              alt='sd'
              ref={imgRef}
              src={Background}
              style={{
                zIndex: 0,
                height: '100%',
                maxWidth: '100%'
              }}
              onLoad={() => setIsImageLoaded(true)}
            />
            {!isVerifyMode &&
              hotSpotList.map((hotspot, index) => {
                const hotspotHeight =
                  (parseFloat(hotspot.Height) * imageDimension.height) /
                  parseFloat(EditorImageHeight)
                const hotspotWidth =
                  (parseFloat(hotspot.Width) * imageDimension.width) /
                  parseFloat(EditorImageWidth)

                return (
                  <div
                    key={index.toString()}
                    id={hotspot.ID}
                    className={
                      currentDropArea === hotspot.ID && showTestColor
                        ? success
                          ? 'dyn-bin-cont-outer blink-bg-correct'
                          : 'dyn-bin-cont-outer blink-bg-wrong'
                        : 'dyn-bin-cont-outer'
                    }
                    style={{
                      left: hotspot.X.concat('%'),
                      top: hotspot.Y.concat('%'),
                      height: hotspotHeight,
                      width: hotspotWidth,
                      flexDirection: hotspot.ColumnCount > 1 ? 'row' : 'column'
                    }}
                    onDrop={(event) => dropAreaOperations(event, hotspot.ID)}
                    onDragOver={(event) => {
                      if (hotspot.Answers.length >= 1) {
                        allowDrop(event)
                      }
                    }}
                  >
                    {hotspot.ColumnCount === 2 ? (
                      <div className='dyn-bin-cont-inner'>
                        {droppedObjects[hotspot.ID] &&
                          _.chunk(droppedObjects[hotspot.ID], 2).map(
                            (ds, i) => {
                              return (
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                  }}
                                >
                                  {ds.map((d, index) => {
                                    return (
                                      <div
                                        className='card-shadow'
                                        onClick={() => {
                                          let headerObjectsCopy = [
                                            ...headerObjects
                                          ]
                                          headerObjectsCopy.push(d.item)
                                          setHeaderObjects(headerObjectsCopy)
                                          let droppedObjectsCopy = {
                                            ...droppedObjects
                                          }
                                          let objArr = droppedObjectsCopy[
                                            hotspot.ID
                                          ].filter((o) => o.item !== d.item)
                                          droppedObjectsCopy[hotspot.ID] =
                                            objArr
                                          if (
                                            droppedObjectsCopy[hotspot.ID]
                                              .length === 0
                                          ) {
                                            delete droppedObjectsCopy[
                                              hotspot.ID
                                            ]
                                          }
                                          setDroppedObjects(droppedObjectsCopy)
                                          let currentAttemptsCopy =
                                            currentAttempts + 1
                                          setCurrentAttempts(
                                            currentAttemptsCopy
                                          )
                                          validateCorrectAnswer(
                                            droppedObjectsCopy,
                                            headerObjectsCopy,
                                            currentAttemptsCopy
                                          )
                                        }}
                                        key={index.toString()}
                                        style={{
                                          left: isFreeForm
                                            ? d.layoutCoords.left
                                            : 0,
                                          top: isFreeForm
                                            ? d.layoutCoords.top
                                            : 0,
                                          position: isFreeForm
                                            ? 'absolute'
                                            : 'relative',
                                          height: '20px',
                                          backgroundColor: AnswerFillColor,
                                          color: AnswerColorFill,
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          borderRadius: '2px',
                                          display: 'flex',
                                          width: isFreeForm
                                            ? '30%'
                                            : hotspot.ColumnCount > 1
                                            ? droppedObjects[hotspot.ID]
                                                .length === 1
                                              ? '100%'
                                              : '45%'
                                            : '100%',
                                          alignSelf:
                                            droppedObjects[hotspot.ID]
                                              .length === 1
                                              ? 'center'
                                              : 'normal',
                                          marginBottom: '5px',
                                          marginRight: '2px'
                                        }}
                                      >
                                        <RectangleContent
                                          contentType={AnswerType}
                                          contentData={d.item.Answer}
                                        />
                                      </div>
                                    )
                                  })}
                                </div>
                              )
                            }
                          )}
                      </div>
                    ) : hotspot.ColumnCount === 3 ? (
                      <div className='dyn-bin-cont-inner'>
                        {droppedObjects[hotspot.ID] &&
                          _.chunk(droppedObjects[hotspot.ID], 3).map(
                            (ds, i) => {
                              //console.log(ds);
                              return (
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                  }}
                                >
                                  {ds.map((d, index) => {
                                    return (
                                      <div
                                        className='card-shadow'
                                        onClick={() => {
                                          let headerObjectsCopy = [
                                            ...headerObjects
                                          ]
                                          headerObjectsCopy.push(d.item)
                                          setHeaderObjects(headerObjectsCopy)
                                          let droppedObjectsCopy = {
                                            ...droppedObjects
                                          }
                                          let objArr = droppedObjectsCopy[
                                            hotspot.ID
                                          ].filter((o) => o.item !== d.item)
                                          droppedObjectsCopy[hotspot.ID] =
                                            objArr
                                          if (
                                            droppedObjectsCopy[hotspot.ID]
                                              .length === 0
                                          ) {
                                            delete droppedObjectsCopy[
                                              hotspot.ID
                                            ]
                                          }
                                          setDroppedObjects(droppedObjectsCopy)
                                          let currentAttemptsCopy =
                                            currentAttempts + 1
                                          setCurrentAttempts(
                                            currentAttemptsCopy
                                          )
                                          validateCorrectAnswer(
                                            droppedObjectsCopy,
                                            headerObjectsCopy,
                                            currentAttemptsCopy
                                          )
                                        }}
                                        key={index.toString()}
                                        style={{
                                          left: isFreeForm
                                            ? d.layoutCoords.left
                                            : 0,
                                          top: isFreeForm
                                            ? d.layoutCoords.top
                                            : 0,
                                          position: isFreeForm
                                            ? 'absolute'
                                            : 'relative',
                                          height: '20px',
                                          backgroundColor: AnswerFillColor,
                                          color: AnswerColorFill,
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          borderRadius: '2px',
                                          display: 'flex',
                                          width: isFreeForm
                                            ? '30%'
                                            : hotspot.ColumnCount > 1
                                            ? droppedObjects[hotspot.ID]
                                                .length === 1
                                              ? '100%'
                                              : '30%'
                                            : '100%',
                                          alignSelf:
                                            droppedObjects[hotspot.ID]
                                              .length === 1
                                              ? 'center'
                                              : 'normal',
                                          marginBottom: '5px',
                                          marginRight: '2px'
                                        }}
                                      >
                                        <RectangleContent
                                          contentType={AnswerType}
                                          contentData={d.item.Answer}
                                        />
                                      </div>
                                    )
                                  })}
                                </div>
                              )
                            }
                          )}
                      </div>
                    ) : (
                      <div className='dyn-bin-cont-inner'>
                        {droppedObjects[hotspot.ID] &&
                          droppedObjects[hotspot.ID].map((d, index) => {
                            // const hBuffer = isLandscape ? hp(6) : hp(2)
                            return (
                              <div
                                className='card-shadow'
                                onClick={() => {
                                  let headerObjectsCopy = [...headerObjects]
                                  headerObjectsCopy.push(d.item)
                                  setHeaderObjects(headerObjectsCopy)
                                  let droppedObjectsCopy = {
                                    ...droppedObjects
                                  }
                                  let objArr = droppedObjectsCopy[
                                    hotspot.ID
                                  ].filter((o) => o.item !== d.item)
                                  droppedObjectsCopy[hotspot.ID] = objArr
                                  if (
                                    droppedObjectsCopy[hotspot.ID].length === 0
                                  ) {
                                    delete droppedObjectsCopy[hotspot.ID]
                                  }
                                  setDroppedObjects(droppedObjectsCopy)
                                  let currentAttemptsCopy = currentAttempts + 1
                                  setCurrentAttempts(currentAttemptsCopy)
                                  validateCorrectAnswer(
                                    droppedObjectsCopy,
                                    headerObjectsCopy,
                                    currentAttemptsCopy
                                  )
                                }}
                                key={index.toString()}
                                style={{
                                  marginTop: '5%',
                                  //flexShrink: 1,
                                  left: isFreeForm ? d.layoutCoords.left : 0,
                                  top: isFreeForm ? d.layoutCoords.top : 0,
                                  position: isFreeForm
                                    ? 'absolute'
                                    : 'relative',
                                  height: '20px',
                                  backgroundColor: AnswerFillColor,
                                  color: AnswerColorFill,
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '2px',
                                  display: 'flex',
                                  width: isFreeForm ? '30%' : '100%'
                                }}
                              >
                                <RectangleContent
                                  contentType={AnswerType}
                                  contentData={d.item.Answer}
                                />
                              </div>
                            )
                          })}
                      </div>
                    )}
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DynamicCategorize
